module.exports = __webpack_public_path__ + "static/img/img1.224c3e5e.jpg";